import {createRouter, createWebHistory} from 'vue-router';
import routerList from './router-list/index.js';
import {getSession, setRouterList} from '@/modules/common';
import PersonalCenter from '@/router/router-list/personal-center';
import Information from '@/router/router-list/information.js';
import pinia from '@/stores/store'
import {useRouterListStore} from '@/stores/routers.js';
let routerListStore = useRouterListStore(pinia)
import {getAuthenticated} from '@/api/account.js';
import {clone} from 'lodash';
const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/container/Login.vue')
    },
    {
      path: '/offline-sign',
      name: 'offline-sign',
      component: () => import('@/views/container/OfflineSign.vue')
    },
  ],
});
export const addRoute = async () => {
  let res
  if (routerListStore.authenticatedList.size > 0) {
    res = routerListStore.authenticatedList
  } else {
    res = await getAuthenticated()
  }
  if (res && Object.entries(res).length > 0) {
    let authenticatedMap = new Map(Object.entries(res))
    let addRouterList = routeFunA(routerList, authenticatedMap)
    routerListStore.setAuthenticatedList(authenticatedMap)
    setRouterList(addRouterList);
    console.log('addRouterList', addRouterList)
    router.addRoute({
      name: 'main-route',
      path: '',
      component: () => import('../views/container/MainHeader.vue'),
      meta: {authRequired: true},
      children: [
        {
          path: '',
          name: 'main-aside',
          redirect: `/${addRouterList?.length > 0 ? addRouterList[0].path : 'login'}`,
          component: () => import('../views/container/MainAside.vue'),
          children: addRouterList,
        },
        PersonalCenter,
        Information
      ],
    });
    router.addRoute(
      {
        path: '/:catchAll(.*)',
        name: '404',
        component: () => import('@/views/container/404.vue')
      },
    )
    // 生产环境 import.meta.env.BASE_URL 会多个前缀，在重定向时删除否则会出现刷新之后出现多个前缀，导致页面404
    let tempPathName = window.location.pathname;
    if(window.location.pathname.indexOf(import.meta.env.BASE_URL)!==-1 && import.meta.env.BASE_URL!=='/'){
      tempPathName = window.location.pathname.slice(import.meta.env.BASE_URL.length)
    }

    await router.replace(tempPathName + window.location.search)
    return true
  } else {
    return false
  }
};
if (getSession()?.['access_token'] && window.location.pathname !== '/login') {
  addRoute().then(() => {})
}
export const removeRoute = () => {
  routerListStore.setAuthenticatedList(new Map())
  setRouterList([]);
  router.removeRoute('main-route')
  router.removeRoute('404')
}

function routeFunA (route, maps, prefix = '') {
  let newRoute = []
  route.forEach(child => {
    let item = clone(child)
    if (maps.get(item.name) || item.meta.noLimits) {
      let mapItem = maps.get(item.name)
      if (mapItem) {
        item.meta.icon = mapItem.icon
        item.meta.title = mapItem.name
      }
      if (item.children?.length > 0) {
        item.children = routeFunA(item.children, maps, `${prefix}/${item.path}`)
        if (item.meta.redirect && item.children?.length > 0) {
          let path = item.children[0].path !== '' ? '/' + item.children[0].path : ''
          item.redirect = `${prefix}/${item.path}${path}`;
        }
      }
      if (item.meta.redirect) {
        if (item.children?.length > 0) {
          newRoute.push(item)
        }
      } else {
        newRoute.push(item)
      }
    } else if (item.path === '') {
      newRoute.push(item)
    }
  })
  return newRoute
}

router.beforeEach((to, form, next) => {
  const session = getSession();
  if (session && session['access_token'] || to.path === '/login' || to.path === '/offline-sign') {
    next()
  } else {
    next({path: '/login'});
  }
});
export default router;
